import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';
import {AuthGuard} from '../auth/auth.guard';

const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'collect',
        loadChildren: () => import('../tab-collect/tab-collect.module').then( m => m.TabCollectPageModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'home',
        loadChildren: () => import('../tab-home/tab-home.module').then( m => m.TabHomePageModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'mine',
        loadChildren: () => import('../tab-mine/tab-mine.module').then( m => m.TabMinePageModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'message',
        loadChildren: () => import('../tab-message/tab-message.module').then( m => m.TabMessagePageModule),
        canActivate: [AuthGuard]
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TabsPageRoutingModule {}
